enum DivisionType {
  Percentage = 'Percentage',
  Amount = 'Amount',
}

export default DivisionType;
